(function certificateRRHHAddControllerDefinition() {
    'use strict';

    angular.module('CertificateRRHH')
        .controller('CertificateRRHHAddController', ['$scope', 'errorsExtend', 'processService', 'configViewService', '$window', '$filter', 'messages', '$translate', '$q',
            function certificateRRHHAddController($scope, errors, processService, configViewService, $window, $filter, messages, $translate, $q) {

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.cancel = function () {
                    $window.history.back();
                };

                $scope.removeEmployeeFile = function (employeeFile) {
                    var index = $scope.employeeFiles.indexOf(employeeFile);
                    if (index > -1) {
                        $scope.employeeFiles.splice(index, 1);
                        $scope.employeeFilesPage.splice(index, 1);
                    }
                };

                $scope.loadViewOptions = function () {
                    if (!$scope.processTypes || $scope.processTypes.length === 0) {
                        configViewService.getById("CPPCertificateRRHH").then(function (result) {
                            if (result.processTypes && result.processTypes.length > 0) {
                                $scope.processTypes = [];
                                angular.forEach(result.processTypes, function (item) {
                                    $scope.loadMetadatas(item);
                                });

                                var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                                $scope.processType = found[0] || $scope.processTypes[0];
                            }
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.loadMetadatas = function (item) {
                    var processType = {
                        name: item.name,
                        id: item.processTypeId,
                        preSelected: item.preSelected,
                        states: item.groupStates,
                        metadatas: [],
                        headers: []
                    };

                    item.metadatas.forEach(function (metadata) {
                        if (metadata.createCriteria) {
                            processType.metadatas.push({
                                idObject: item.name.replace(/ /g, '_') + metadata.systemName,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined,
                                metadataSearchTypeTo: undefined,
                                metadataType: metadata.metadataType.toLowerCase(),
                                metadataSystemName: metadata.systemName,
                                metadataIsRequired: metadata.createCriteria.isRequired,
                                metadataLabel: metadata.createCriteria.name,
                                metadataReadOnly: !metadata.createCriteria.isEditable,
                                metadataEnabled: true,
                                metadataOptions: metadata.metadataOptionValues,
                                maskOptions: metadata.metadataMaskOption,
                                order: metadata.createCriteria.order
                            });
                        }
                    });

                    processType.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    processType.headers.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    $scope.processTypes.push(processType);
                };

                $scope.selectProcessType = function (processType) {
                    $scope.processType = processType;
                };

                $scope.save = function () {
                    if (!$scope.certificateRRHHAdd.$valid) {
                        $scope.certificateRRHHAdd.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if ($scope.employeeFiles.length <= 0) {
                        errors.showError('DocumentVerifyEmployeeFile');
                        return false;
                    }

                    var employeeFiles = $scope.employeeFiles;

                    if (employeeFiles.length === 0) {
                        errors.showWarning('EmployeeFileSelectItemWarning');
                        return false;
                    }

                    return messages.showConfirm('RequestMultipleCertificatesConfirm').then(function (result) {
                        if (result) {
                            $scope.loading = true;
                            $scope.data.success = 0;
                            $scope.data.total = employeeFiles.length;
                            $scope.data.legajos = '';

                            var promise = $q.all([]);

                            angular.forEach(employeeFiles, function (item) {
                                promise = promise.finally(function () {
                                    return createCertificate(item);
                                });
                            });

                            promise.finally(function () {
                                $scope.loading = false;
                                if ($scope.data.legajos) {
                                    $scope.data.legajos = $scope.data.legajos.slice(0, -2);
                                }

                                errors.showSuccess('EmployeeFileCertificateSolicitudeResult', 'InfoTitle', { data: $scope.data }).then(function () {
                                    $window.history.back();
                                });
                            });
                        }
                    });
                };

                $scope.load = function () {
                    $scope.employeeFiles = [];
                    $scope.accordionStatus = true;
                    $scope.loading = false;
                    $scope.employeeFilesPage = [];
                    $scope.headers = ['EmployeeFileNumber', 'UserLastName', 'UserFirstName', 'EmployeeFileInDate'];

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 8,
                        from: 0
                    };

                    $scope.loadViewOptions();
                };

                $scope.load();

                $scope.setPagingData = function () {
                    var page = $scope.data.currentPage;
                    $scope.data.totalItems = $scope.employeeFiles.length;
                    $scope.data.from = 1 + ($scope.data.itemsPerPage * (page - 1));

                    var pagedData = $scope.employeeFiles.slice(
                        (page - 1) * $scope.data.itemsPerPage,
                        page * $scope.data.itemsPerPage
                    );

                    var removeValFromIndex = new Array(1, 4, 5);

                    pagedData.forEach(function (value) {
                        if (value.metadata.length > $scope.headers.length) {
                            value.metadata = $.grep(value.metadata, function (n, i) {
                                return $.inArray(i, removeValFromIndex) === -1;
                            });
                        }
                    });

                    $scope.employeeFilesPage = pagedData;
                };

                $scope.$watchCollection("employeeFiles", function () {
                    $scope.setPagingData();
                });

                var createCertificate = function (employeeFile) {
                    if (employeeFile) {
                        var params = {
                            processTypeId: $scope.processType.id,
                            processTypeName: $scope.processType.name,
                            organizationalUnitId: employeeFile.organizationalUnitId,
                            legajoId: employeeFile.id
                        };

                        return processService.createCertificate(params).then(function () {
                            $scope.data.success++;
                        }, function () {
                            $scope.data.legajos += employeeFile.metadata[0] + ', ';
                        });
                    }

                    return false;
                };
            }
        ]);
})();
